<template>
  <comBox>
    <template v-slot:name><h4>{{$store.state.module1.isChina?'室外综合指数':'outdoor data'}}(AQI:{{proCity}})</h4></template>
    <template v-slot:other>{{crTime.substring(0,16)}}</template>
    <template v-slot:content>
      <div>
        <div class="bug"><div class="yu">{{aqi?aqi[1].value:'--'}}</div><water v-if="aqi" type="aqi" :num="aqi[1].value" style="position:absolute;left:68%;top:15%;zIndex:199;cursor:pointer;"></water></div>
        <div class="bugBottom">
          <span>{{aqi?'AQI':'--'}}</span>
        </div>
      </div>
      <div style="background:rgba(0,0,0,0.01);width:100%;height:2rem;borderRadius:0.06rem;marginTop:0.25rem">
      <h5 style="textAlign:left;marginBottom:0.1rem;">{{$store.state.module1.isChina?'最近一周':'Latest week'}}</h5>
        <div id="pm-num">
         </div>
      </div>
    </template>
  </comBox>
</template>

<script>
import { Column } from '@antv/g2plot'
import comBox from '../comBox/comBox.vue'
import water from '../water/water.vue'
export default {
  props: ['crTime', 'aqi', 'proCity'],
  components: {
    comBox,
    water
  },
  data () {
    return {
      todo: '',
      columnPlot: null,
      list: null,
      size: 12,
      showRant: false
    }
  },
  methods: {
    showR () {
      alert(1)
    },
    trans (item) {
      if (item.name !== 'TEMP' && item.name !== 'RH') {
        this.todo = item
      }
    },
    initC () {
      if (this.columnPlot) {
        this.columnPlot.destroy()
        this.upEh()
      } else {
        this.upEh()
      }
    },
    upEh () {
      var self = this
      this.columnPlot = new Column('pm-num', {
        data: self.aqi,
        color: '#00C657',
        xField: 'type',
        yField: 'value',
        xAxis: {
          label: {
            style: {
              fontSize: self.size
            }
          }
        },
        meta: {
          type: {
            alias: self.$store.state.module1.isChina ? '日期' : 'date'
          },
          value: {
            alias: self.$store.state.module1.isChina ? '数值' : 'value'
          }
        }
      })
      this.columnPlot.render()
    }
  },
  watch: {
    aqi (value) {
      this.$nextTick(() => {
        this.initC()
        if (value) {
          var oWidth = document.getElementById('app').offsetWidth
          if (oWidth <= 1440) {
            this.size = 8
          }
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.bug{
  margin:0.2rem 0;
  .yu{
    font-size:0.8rem;
    font-weight:blod;
    position:relative;
    cursor:pointer;
  }
}
.bugBottom{
  span{
    margin:0.1rem 0.1rem;
  }
  span:first-child{
    font-weight:bold;
    opacity:0.8;
  }
  span:last-child{
    opacity:0.8;
  }
}
#pm-num{
   width:100%;
   height:1.7rem;
}

</style>
